module.exports = "ngb-carousel, ng-template, img{\r\n    width: 100% ;\r\n    height: 100vh;\r\n   \r\n}\r\nh3{\r\n    color:white;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/home/slider/slider.component.css
// module id = ./src/app/pages/home/slider/slider.component.css
// module chunks = main